import { useQuery, useQueryClient } from '@tanstack/react-query'
import { currentSelfQueryOptions } from '../../lib/performance/queryOptions'

export const useCurrentSelf = (enabled = true) => {
  const queryClient = useQueryClient()
  return useQuery(currentSelfQueryOptions(queryClient, enabled))
}
